// extracted by mini-css-extract-plugin
export var messageSideLeft = "_lw-1";
export var messageSideRight = "_lw-2";
export var orderLookupBubbleContainer = "_lw-0";
export var submitButton = "_lw-3";